import React from 'react';
export function Footer() {
  return <footer className="bg-[#04060C] py-12 px-5 md:px-8 border-t border-[#15203B]" data-id="element-178">
      <div className="max-w-5xl mx-auto text-center" data-id="element-179">
        <div className="text-white font-serif font-bold text-xl tracking-wide mb-6" data-id="element-180">
          Protocolo Silencio TTPM™
        </div>

        <div className="flex justify-center gap-6 mb-8" data-id="element-181">
          <a href="#" className="text-gray-500 hover:text-[#F6C65B] transition-colors text-sm" data-id="element-182">
            Política de privacidad
          </a>
          <a href="#" className="text-gray-500 hover:text-[#F6C65B] transition-colors text-sm" data-id="element-183">
            Términos y condiciones
          </a>
          <a href="#" className="text-gray-500 hover:text-[#F6C65B] transition-colors text-sm" data-id="element-184">
            Contacto
          </a>
        </div>

        <div className="text-gray-600 text-xs leading-relaxed max-w-3xl mx-auto space-y-4" data-id="element-185">
          <p data-id="element-186">
            Este producto es educativo y de apoyo. No diagnostica, trata ni cura
            tinnitus u otra condición médica. Si tienes síntomas persistentes,
            dolor, pérdida auditiva, mareos o cambios repentinos en la audición,
            consulta con un profesional de salud.
          </p>
          <p data-id="element-187">
            Este sitio no es parte del sitio web de Facebook o Facebook Inc.
            Además, este sitio NO está respaldado por Facebook de ninguna
            manera. FACEBOOK es una marca registrada de FACEBOOK, Inc.
          </p>
          <p data-id="element-188">
            &copy; {new Date().getFullYear()} Protocolo Silencio TTPM™. Todos
            los derechos reservados.
          </p>
        </div>
      </div>
    </footer>;
}